import { useState } from 'react';

import DiscountIcon from '../../../assets/icons/discount-info/discount.svg';
import type { DiscountBlock } from '../types/discount.types';

export interface DiscountInfoProps {
  discountBlocks?: DiscountBlock[];
}

const DiscountInfo = ({ discountBlocks = [] }: DiscountInfoProps) => {
  const [openDiscountId, setOpenDiscountId] = useState<number | null>(null);

  if (!discountBlocks || discountBlocks.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 w-full">
      {discountBlocks.map((block, index) => {
        const heading = block.delegateDiscountTitle ?? `Discount ${index + 1}`;
        const subheading = block.delegateDiscountDescription ?? '';
        const bullets = block.delegateDiscountAccordion ?? [];
        const isOpen = openDiscountId === index;

        return (
          <div
            key={index}
            className="bg-transparent overflow-hidden transition-all duration-300 ease-in-out w-full opacity-100"
          >
            <button
              type="button"
              onClick={() => setOpenDiscountId(isOpen ? null : index)}
              className="w-full flex items-center gap-[20px] text-left transition-colors rounded-lg min-h-[44px]"
            >
              <div
                className="flex-shrink-0 flex items-center justify-center w-[44px] h-[44px] min-w-[44px]"
              >
                <img
                  src={DiscountIcon}
                  alt="Discount"
                  className="w-[44px] h-[44px]"
                />
              </div>

              <div className="flex-1 min-w-0 text-left">
                <h3 className="font-['Noto_Sans'] text-[16px] font-semibold leading-[24px] text-[#002B66] m-0">
                  {heading}
                </h3>
                <p className="m-0 font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[rgba(0,43,102,0.70)] overflow-hidden text-ellipsis">
                  {subheading}
                </p>
              </div>

              <div className="flex-shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
            </button>

            {isOpen && (
              <div className="pl-[4px] pr-0 pt-[20px] pb-[12px]">
                <ul className="space-y-[8px] m-0 p-0 list-none">
                  {bullets.map((bullet, bulletIndex) => (
                    <li key={bulletIndex} className="flex items-start gap-[8px]">
                      <span className="flex-shrink-0 mt-[1px] font-['Noto_Sans'] text-[12px] font-semibold leading-[18px] text-[#667085]">
                        •
                      </span>
                      <span className="font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[#667085]">
                        {bullet}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DiscountInfo;
